import React, { FormEvent, ForwardedRef, forwardRef } from 'react'
import * as S from './styles'

export type Props = {
  placeholder?: string
  onSearch?: (e: FormEvent<HTMLFormElement>) => void
  animated?: boolean
  // style?: React.CSSProperties
  // id?: string
}

const Search = forwardRef(
  (
    { placeholder = 'Search by Address / Txn hash / Block / Token', onSearch, animated = false }: Props,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <S.SearchForm
        onSubmit={onSearch}
        className={animated ? 'animate__animated animate__bounceInLeft animate__delay-1s' : ''}
      >
        <S.SearchInput type="text" placeholder={placeholder} ref={ref} />
        <S.SearchButton type="submit">
          <img src="/assets/img/icon_search.png" alt="icon_search" />
        </S.SearchButton>
      </S.SearchForm>
    )
  },
)

export default Search
